module.exports = __webpack_public_path__ + "static/media/sanxion.96ff7886.webm";


//////////////////
// WEBPACK FOOTER
// ./src/Videos/sanxion.webm
// module id = 57
// module chunks = 0